export default __webpack_public_path__ + "static/hanami-9fb75a2c7496bd52b65b158ca835c956.webp";